import { GLOBAL_LOGOUT } from '../actionTypes/GlobalLogoutActionTypes';

export const jcpGlobalLogout = () => ({ // eslint-disable-line
    type: GLOBAL_LOGOUT,
});
